import { Card, CardBody } from '@chakra-ui/react';

import { AdminCompaniesTable } from './AdminCompaniesTable';

export function AdminCompaniesList(): JSX.Element {
  return (
    <Card>
      <CardBody>
        <AdminCompaniesTable />
      </CardBody>
    </Card>
  );
}
